const customSGModal = document.querySelector("#custom-sg-modal");

const customSGCloseBtn = document.querySelector("custom-sg-close");

document.addEventListener("click", function (e) {
  const customSGTriggerBtn = e.target.matches(".custom-sg-open");
  if (customSGTriggerBtn) {
    customSGModal.style.display = "block";
  }
});

customSGCloseBtn.onclick = function () {
  customSGModal.style.display = "none";
};

window.onclick = function (event) {
  if (event.target == customSGModal) {
    customSGModal.style.display = "none";
  }
};
